import React, { useEffect } from "react";

const CookiebotIntegration = () => {
  useEffect(() => {
    // Script erstellen
    const script = document.createElement("script");
    script.id = "Cookiebot";
    script.src = "https://consent.cookiebot.com/uc.js";
    script.async = true;
    script.type = "text/javascript";
    script.setAttribute("data-cbid", "56139bc4-5134-4d98-8292-adea69711063");
    script.setAttribute("data-blockingmode", "auto");

    // Script in den Body einfügen
    document.body.appendChild(script);

    return () => {
      // Aufräumen: Script entfernen, wenn die Komponente unmountet wird
      document.body.removeChild(script);
    };
  }, []);

  return null; // Da es keine visuelle Komponente gibt
};

export default CookiebotIntegration;
